import script from "./ourwork.vue?vue&type=script&setup=true&lang=js"
export * from "./ourwork.vue?vue&type=script&setup=true&lang=js"

import "./ourwork.vue?vue&type=style&index=0&id=2e2bdf66&lang=less"
import "./ourwork.vue?vue&type=style&index=1&id=2e2bdf66&lang=less&scoped=true"

import exportComponent from "D:\\WorkSpace\\girard\\girard-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e2bdf66"]])

export default __exports__